<template>
    <div @click="setActive()" @dblclick="openDetailEmit" :class="colorClass">
        <template v-for="(tag, index) in gptags">
                <span :key="tag[0]"
                      :style="{'max-width': (index >= 2 ? getSpanWidth : 80) + 'px', 'min-width': (index >= 2 ? getSpanWidth : 80) + 'px'}">
                    <template v-if="types === 1 && gpData0 && gpData0.hasOwnProperty(tag[1])">
                        <template v-if="tag[1] === 'symbol'">
                            {{gpData0[tag[1]].substr(2)}}
                        </template>
                        <template v-else>
                            {{gpData0[tag[1]]}}{{tag[1] === 'gain_p' ? '%' : (tag[1] === 'chenjiao_price' ? '亿' : '')}}
                        </template>
                    </template>
                    <template v-else-if="types === 2 && gpData2_ && gpData2_.hasOwnProperty(tag[1])">
                        <template v-if="tag[1] === 'latestPrice'">
                            <p>{{gpData2_[tag[1]]}}</p>
                            <b v-if="gpData2_ && gpData2_.code" :ref="gpData2_.code + '_b_dom'"></b>
                        </template>
                        <template v-else-if="tag[1] === 'name'">
                            {{gpData2_[tag[1]].trim()}}
                        </template>
                        <template v-else-if="tag[1] === 'code' || tag[1] === 'symbol'">
                            {{gpData2_[tag[1]].substr(2)}}
                        </template>
                        <template v-else>
                            {{gpData2_[tag[1]]}}{{tag[1] === 'gain' ? '%' : (tag[1] === 'totalMarketValue' ? '亿' : '')}}
                        </template>
                    </template>
                    <template v-else>-</template>
                </span>
        </template>
    </div>
</template>
<!--|| this.choisCode === item.symbol, -->
<script>
    export default {
        name: "TradePageGpItem",
        props: {
            'gpData': String, 'gptags': Array, 'trIndex': Number, 'types': Number, 'tabId': Number
        },
        data: function () {
            return {
                actived: null,
                colorClass: null,
                bShow: false,
                latestPrice: 0,
                gpData2_: null,
                getSpanWidth: (Math.max(window.innerWidth, 1300) - 246) / (this.gptags.length - 2) - 10
            }
        },
        created() {
            this.getSpanWidth = (Math.max(window.innerWidth, 1300) - 246) / (this.gptags.length - 2) - 10;
            window.addEventListener('resize', function () {
                setTimeout(function () {
                    this.getSpanWidth = (Math.max(window.innerWidth, 1300) - 246) / (this.gptags.length - 2) - 10;
                }.bind(this), 1000);
            }.bind(this))
        },
        mounted() {
            try {
                this.gpData2_ = Object.assign({}, this.$store.state.gupiaolist_sz.entities.patrons[this.gpData], {});
            } catch (e) {
                this.gpData2_ = null;
            }
        },
        computed: {
            // 用大盘code返回股票详情
            gpData0: function () {
                if (this.$store.state.gupiaolist_dp) {
                    const tmp = this.$store.state.gupiaolist_dp.entities.patrons[this.gpData.toLocaleUpperCase()];
                    this.setColor(tmp);
                    return tmp;
                }
                return null;
            },
            // 用股票code返回股票详情
            gpData2: function() {
                if (this.$store.state.gupiaolist_sz && this.gpData) {
                    const tmp = this.$store.state.gupiaolist_sz.entities.patrons[this.gpData];
                    this.setColor(tmp);
                    return tmp;
                }
                return null;
            }
        },
        watch: {
            // 检测大盘数据变化，改变颜色
            gpData0: function (value) {
                if (value && value.hasOwnProperty('gain')) {
                    this.colorClass = {
                        'red': +value.gain > 0, 'green': +value.gain < 0
                    };
                }
            },
            gpData2: function (value, ov) {
                if (value && value.hasOwnProperty('gain')) {
                    this.colorClass = {
                        'red': +value.latestPrice > +value.preClose, 'green': +value.latestPrice < +value.preClose
                    };
                    if (+value.latestPrice !== +ov.latestPrice) {
                        const bdom = this.$refs[value.code + '_b_dom'];
                        if(bdom && bdom.length > 0) {
                            bdom[0].style.opacity = 0.5;
                            setTimeout(() => {
                                bdom[0].style.opacity = 0;
                            }, 600)
                        }
                    }
                    this.gpData2_ = value;
                }
            }
        },
        methods: {
            openDetailEmit() {
                this.$emit('openDetail', true);
            },
            setActive() {
                // 对于只有横线的时候，点击不设置激活状态，啥也不干
                if (this.types === 2 && (!this.gpData2 || this.gpData2 && !this.gpData2.hasOwnProperty('code') && !this.gpData2.hasOwnProperty('symbol'))) {
                    return false;
                }
                this.$emit('setActive', this.types === 1 ? this.gpData0.symbol : (this.gpData2.code || this.gpData2.symbol));
            },
            setColor(temp) {
                if (temp && temp.hasOwnProperty('gain')) {
                    this.colorClass = {
                        'red': +temp.gain > 0, 'green': +temp.gain < 0
                    };
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "TradePageGpItem";
</style>
